<template>
  <div>
    <AppHeader title="实验室监控"/>
    <div class="search-panel">
      <div class="search-container">
        <i class="iconfont icon-search"></i>
        <input
          v-model="searchKeyword"
          type="text"
          placeholder="搜索仪器设备..."
          class="search-input"
          @input="handleSearch"
        />
        <i v-if="searchKeyword" class="iconfont icon-close" @click="clearSearch"></i>
      </div>
    </div>
    <Panel class="tabs monitor" :title="false">
      <div slot="content">
        <div class="line" v-for="(equipment,idx) of filteredEquipments" :key="equipment.id">
          <div style="font-size: 20px; font-weight: 400;display: flex" @click="showOrHide(equipment)">
            <div class="flex-item-auto">{{ equipment.text }}</div>
            <div style="font-weight: bold;"><i class="iconfont icon-next" style="padding: 0 10px"></i></div>
          </div>
          <div v-if="showId === equipment.id">
            <div class="grid gap10">

              <div class="grid-cell-1-3" v-for="(sensor,idx) of sensors" v-if="!sensor.hidden">

                <div class="sensor" @click="showSensorHistory(sensor)">
                  <div :class="`sensor-value ${sensor.statusClass}`" style="white-space: nowrap;overflow: hidden">{{ sensor.valueText }}</div>
                  <div class="sensor-title">{{ sensor.title }}</div>
                </div>
              </div>
            </div>
            <div class="grid gap10" v-for="(video,idx) of videos">
              <div class="grid-cell-1-2 video-location">
                {{ video.videoName }}
              </div>
              <div class="grid-cell-1-4">
                <div class="video live" @click="showLive(equipment.id, video.videoCode)">
                  <i class="iconfont icon-live"></i>
                </div>
              </div>
              <div class="grid-cell-1-4">
                <div class="video pc" @click="showScreen(equipment.id)">
                  <i class="iconfont icon-monitor"></i>
                </div>
              </div>
            </div>

            <div class="command-box" v-for="item in popupController" @click="showConfirmation(item)">
              <div class="command-name">{{item.sensorName}}</div>
              <div class="command-type">{{item.controllerType}}</div>
            </div>

          </div>
        </div>
      </div>
    </Panel>

    <mt-popup
        v-model="popupVisible"
        style="top:200px"
    >
      <video
          id="video"
          preload="auto"
          muted
          class="video-js vjs-default-skin"
          style="width: 100%; height: auto; object-fit: fill"
      >
        <source type="application/vnd.apple.mpegurl" ref="myVideo"/>
      </video>
    </mt-popup>
    <mt-popup
        v-model="confirmationVisible"
        popup-transition="popup-fade"
        class="sensor-popup"
    >

      <div class="popup-content popup-2" style="text-align: center;">
        <img src="../assets/images/icon_wen.png" style="display: block;width: 15%;height: 15%;margin: 0 auto">
        <p class="p-1">对{{selectedItem.sensorName}}执行“{{selectedItem.controllerType}}”指令?</p>
        <p class="p-2">确认后，将向该传感器下发指令并执行</p>
        <div  style="margin-top: 30%">
          <mt-button style="width: 80%" type="primary" @click="executeCommand">确认执行</mt-button>
        </div>
        <div style="margin-top: 4%">
          <mt-button style="width: 80%" type="" @click="confirmationVisible = false">取消</mt-button>
        </div>
      </div>
    </mt-popup>


    <mt-popup
        v-model="confirmationSuccess"
        popup-transition="popup-fade"
        class="sensor-popup"
    >
      <div class="popup-content popup-2" style="text-align: center;">
        <img src="../assets/images/icon_chenggong.png" style="display: block;width: 15%;height: 15%;margin: 0 auto">
        <p class="p-1">指令已下发</p>
        <div  style="margin-top: 30%">
          <mt-button style="width: 80%" type="primary" @click="confirmationSuccess=false;confirmationVisible = false;popupVisible=false">好的</mt-button>
        </div>

      </div>
    </mt-popup>

  </div>
</template>

<style lang="scss">
.search-panel {
  background: #eee;
  padding: 15px 20px;
  margin: 0 -20px;
}

.search-container {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 25px;
  padding: 8px 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  .iconfont {
    font-size: 18px;
    color: #999;

    &.icon-search {
      margin-right: 8px;
    }

    &.icon-close {
      margin-left: 8px;
      cursor: pointer;
      color: #666;

      &:active {
        color: #333;
      }
    }
  }

  .search-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    color: #333;

    &::placeholder {
      color: #999;
    }
  }
}

.monitor {
  .line {
    padding: 10px 15px;
  }
}

.video-location {
  text-align: center;
  font-size: 14px;
  font-weight: 500;
}

.sensor {
  cursor: pointer;
  width: 80px;
  height: 80px;
  text-align: center;
  background-color: #fafafa;
  box-shadow: rgba(0, 0, 0, 0.18) 0px 3px 10px;
  border: 1px solid #eaeaea;
  border-radius: 12%;
  margin: 10px 0px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: rgba(0, 0, 0, 0.25) 0px 5px 15px;
  }

  &:active {
    transform: translateY(0);
    box-shadow: rgba(0, 0, 0, 0.18) 0px 3px 10px;
  }
}

.sensor-value {
  font-size: 13px;
  font-weight: 600;
  margin-top: 6px;

  &.yellow {
    color: #f39c12;
  }

  &.green {
    color: green;
  }

  &.red {
    color: red;
  }
}

.sensor-title {
  font-size: 11px;
  font-weight: 600;
  color: #5e5e5e;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 90%;
}

.video {
  background: RGBA(124, 138, 202, .9);
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #fff;

  .iconfont {
    font-size: 22px !important;
  }
}

.popup-2{
  margin-top: 5%;
}
.p-1{
  font-weight: bold;
  font-size: 19px !important;
}
.p-2{
  color: #7d7d7d;
}
.command-box {
  display: inline-block;
  padding: 10px 20px;
  margin: 4px;
  background-color: #f0f0f0;
  border-radius: 5px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: default;
}
.command-box:hover {
  cursor: pointer;
  background-color: #e0e0e0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transform: translateY(-2px);
}

.command-box:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}
.command-name {
  font-size: 14px;
  color: #333;
}
.command-type {
  font-size: 12px;
  color: #ff6600;
}
.command-title{
  margin: 10px 0 10px 20px;
}
.command-par{
  margin: 0 20px;
}
.sensor-popup {
  width: 90%;
  max-width: 500px;
  border-radius: 8px;
  overflow: hidden;
}
.popup-header {
  background-color: #f8f8f8;
  padding: 15px;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-weight: bold;
}
.popup-content {
  padding: 15px;
  background-color: white;
}




</style>

<script>
import AppHeader from "@/components/AppHeader";
import Panel from "@/components/Panel";
import {mapState} from 'vuex';
import {Indicator, Popup} from 'mint-ui';
import {Toast, MessageBox} from 'mint-ui';
import 'video.js/dist/video-js.css'
import 'videojs-contrib-hls'
import "@videojs/http-streaming"
import videojs from 'video.js'
import sec from "@/plugins/user";

export default {
  components: {
    AppHeader,
    Panel,
    Popup
  },
  data() {
    return {
      showId: null,
      videos: [],
      sensors: [],
      popupEqName: null,
      popupController:[],
      isAdmin:false,
      selectedItem: {}, // 用于存储选中的项
      confirmationVisible: false,
      confirmationSuccess:false,
      popupVisible: false,
      showController:false,
      player: null,
      searchKeyword: ''
    }
  },
  computed: {
    ...mapState({
      // 为了能够使用 `this` 获取局部状态，必须使用常规函数
      equipments(state) {
        return state.equipments
      }
    }),
    filteredEquipments() {
      if (!this.searchKeyword || this.searchKeyword.trim() === '') {
        return this.equipments;
      }
      const keyword = this.searchKeyword.toLowerCase().trim();
      return this.equipments.filter(equipment => {
        return equipment.text && equipment.text.toLowerCase().includes(keyword);
      });
    }
  },
  methods: {
    handleSearch() {
      // 搜索处理已经通过 computed 属性 filteredEquipments 实现
    },
    clearSearch() {
      this.searchKeyword = '';
    },
    showConfirmation(item) {
      console.log("item:",item)
      this.selectedItem = item;
      this.confirmationVisible = true;
    },
    executeCommand() {
      // 执行指令的逻辑，例如调用API
      this.$http.post('/portal/sensorEvent/controllerSensor?id='+this.selectedItem.sensorId+"&type="+this.selectedItem.controllerType).then(res => {
        if(res.success){
          this.confirmationSuccess = true
          this.confirmationVisible = false;
          this.popupVisible = false; // 可选：关闭主弹出框
        }else {
          this.confirmationVisible = false;

        }
      })
    },
    showOrHide(equipment) {
      const that = this
      if (this.showId === equipment.id) {
        this.showId = ''
      } else {
        that.sensors = []
        that.videos = []
        this.$http.post(`/portal/videos/initEquipVideos?equipmentId=${equipment.id}`).then(res => {
          that.videos = res.data
        })
        this.$http.post(`/portal/equipment/refreshStatus?id=${equipment.id}`).then(res => {
          that.sensors = res.map(s => {
            if (s.statusText === 2) {
              s.statusClass = 'yellow'
            } else if (s.statusText > 2 && s.statusText !== '水箱' && s.statusText !== '抽湿机') {
              s.statusClass = 'red'
            } else {
              s.statusClass = 'green'
            }
            return s
          })
        })
        if(that.isAdmin){
          this.$http.post('/portal/sensorEvent/queryControllerList?equipmentId='+equipment.id).then(res => {
            if(res.success){
              that.popupController=res.data
              that.showController=true
            }
          })
        }


        this.showId = equipment.id
      }
    },
    showLive(equipmentId, videoCode) {
      const that = this
      this.$http.post(`/portal/ffmpegTask/start/stream?ffmpegType=real_time&equipmentId=${equipmentId}&videoCode=${videoCode}`, {indicator: false}).then(res => {
        if (res.success) {
          const videoUrl = `${that.hlsUrl}/${videoCode}/index.m3u8`
          this.waitAndPlay(videoUrl, "视频转换中...", "视频转换中或转换失败，请稍后再试", 9)
        }
      })
    },
    showScreen(equipmentId) {
      const videoUrl = `${this.hlsUrl}/${equipmentId}/index.m3u8`
      this.waitAndPlay(videoUrl, "查找客户端录屏文件...", "未找到客户端录屏文件", 1)
    },
    waitAndPlay(videoUrl, waitMsg, errorMsg , retryCnt){
      const that = this
      Indicator.open(waitMsg)
      that.waitUntilSuccess(videoUrl, 500, retryCnt, function () {
        Indicator.close()
        that.popupVisible = true
        that.$nextTick(function () {
          that.playVideo(videoUrl)
        })
      }, function () {
        Indicator.close()
        Toast(errorMsg)
      })
    },
    waitUntilSuccess(url, delay, retryCnt, successFun, errorFun) {
      const that = this
      let cnt = 0

      function doWait() {
        setTimeout(function () {
          that.$http.get(url, {autoToast: false, indicator: false}).then(res => {
            console.log(res)
            if (res.success === undefined) {
              //m3u8 ok !
              successFun()
            } else {
              cnt++
              if (cnt <= retryCnt) {
                doWait()
              } else {
                errorFun()
              }
            }
          })
        }, delay)
      }
      doWait();
    },
    playVideo(url) {
      const that = this
      that.player.src({
        src: url,
        type: 'application/vnd.apple.mpegurl'
      })
      // that.player.load()
      setTimeout(function (){
        that.player.play()
      },500)

    },
    showSensorHistory(sensor) {
      // 获取传感器ID，优先使用 sensor.id，如果没有则尝试使用 sensor.sensor.id
      const sensorId = sensor.id || (sensor.sensor && sensor.sensor.id)
      if (!sensorId) {
        Toast('无法获取传感器ID')
        return
      }
      // 使用 Vue Router 跳转到传感器历史数据页面，传递更多参数用于图表查询
      this.$router.push({
        name: 'sensor-history',
        query: {
          sensorId: sensorId,
          equipmentId: sensor.equipmentId || '',
          sensorCode: sensor.code || '',
          sensorName: sensor.name || '',
          uniqueId: sensor.uniqueId || '',
          sensorVersion: sensor.sensorVersion || 1,
          title: sensor.title || ''
        }
      })
    },
  },
  mounted() {
    this.isAdmin = sec.hasAnyRole('admin', 'allAdmin')
    this.$nextTick(function (){
      this.player =  videojs('video', {
        bigPlayButton: true,
        textTrackDisplay: false,
        posterImage: false,
        errorDisplay: false,
        controls: true,
        hls: {
          withCredentials: true
        }
      }, function () {

      })
    })
  }
}
</script>
